import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Combos/getComboCausaEliminacion`, method: 'GET', body: null})
}
